class TastemakersManager {
  /** @type {Set<HTMLElement>} */
  static items = new Set()

  /** @type {Record<'update', (() => void)[]>} */
  static listeners = { update: [] }

  /** @param {HTMLElement} item  */
  static register (item) {
    this.items.add(item)

    this.#emit('update')
  }

  /** @param {HTMLElement} item */
  static unregister (item) {
    this.items.delete(item)

    this.#emit('update')
  }

  /**
   * @param {keyof typeof TastemakersManager['listeners']} event
   * @param {() => void} callback
   */
  static on (event, callback) {
    this.listeners[event].push(callback)
  }

  /**
   * @param {keyof typeof TastemakersManager['listeners']} event
   */
  static #emit (event) {
    this.listeners[event].forEach(callback => {
      callback()
    })
  }
}

window.BAO.Tastemakers = {
  manager: TastemakersManager,
}
